export const themeColors = [
  {
    color: 'primary',
    name: 'Primary',
    description: 'Buttons, labels, graphs.',
  },
  {
    color: 'secondary',
    name: 'Secondary',
    description: 'Light text, buttons, labels, graphs.',
  },
  {
    color: 'success',
    name: 'Success',
    description: 'Buttons, labels, graphs.',
  },
  {
    color: 'info',
    name: 'Info',
    description: 'Buttons, labels, graphs.',
  },
  {
    color: 'danger',
    name: 'Danger',
    description: 'Buttons, labels, graphs.',
  },
  {
    color: 'warning',
    name: 'Warning',
    description: 'Buttons, labels, graphs.',
  },
  {
    color: 'gray',
    name: 'Gray',
    description: 'Buttons, labels, graphs.',
  },
  {
    color: 'dark',
    name: 'Dark',
    description: 'Buttons, labels, graphs.',
  },
]

export const extraColors = [
  {
    color: '#36e9f6',
    name: 'Teal',
    description: 'Graphs, tables, labels, etc.',
  },
  {
    color: '#ed34b8',
    name: 'Violet',
    description: 'Graphs, tables, labels, etc.',
  },
  {
    color: '#8f4ed6',
    name: 'Purple',
    description: 'Graphs, tables, labels, etc.',
  },
  {
    color: '#d40d52',
    name: 'Ruby',
    description: 'Graphs, tables, labels, etc.',
  },
  {
    color: '#ff842b',
    name: 'Orrange',
    description: 'Graphs, tables, labels, etc.',
  },
  {
    color: '#1b9a7c',
    name: 'Dark Green',
    description: 'Graphs, tables, labels, etc.',
  },
  {
    color: '#d3ff00',
    name: 'Toxic',
    description: 'Graphs, tables, labels, etc.',
  },
  {
    color: '#81513e',
    name: 'Brown',
    description: 'Graphs, tables, labels, etc.',
  },
]

export const buttonGradients = [
  { color: 'primary' },
  { color: 'secondary' },
  { color: 'success' },
  { color: 'info' },
  { color: 'danger' },
  { color: 'warning' },
  { color: 'gray' },
  { color: 'dark' },
]
